import { render, staticRenderFns } from "./TwelveNav.vue?vue&type=template&id=3730ed32"
import script from "./TwelveNav.vue?vue&type=script&lang=js"
export * from "./TwelveNav.vue?vue&type=script&lang=js"
import style0 from "./TwelveNav.vue?vue&type=style&index=0&id=3730ed32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports